module.exports = __webpack_public_path__ + "static/media/snow.a8d5b7e9.svg";